module.exports = __webpack_public_path__ + "h5assets/img/new-collabs-level-company-en@2x.1fbcd4b.png";